import axios from "axios";

export const API_URL = `${process.env.REACT_APP_API_URL}/warehouses`;

// CREATE =>  POST: add a new product to the server
export function createWarehouse(warehouse) {
    return axios.post(API_URL, { ...warehouse });
}

// READ
export function getAllWarehouses() {
    return axios.get(API_URL);
}

export function getPaginatedWarehouses(queryParams) {
    return axios.post(`${API_URL}/list`, { ...queryParams });
}

export function getWarehouseById(warehouseId) {
    return axios.get(`${API_URL}/${warehouseId}`);
}



// // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// // items => filtered/sorted result
// export function findProducts(queryParams) {
//     return axios.post(`${API_URL}/find`, { queryParams });
// }

// UPDATE => PUT: update the warehouse on the server
export function updateWarehouse(warehouseId, warehouse) {
    return axios.put(`${API_URL}/${warehouseId}`, { ...warehouse });
}


// DELETE => delete the product from the server
export function deleteWarehouse(warehouseId) {
    return axios.delete(`${API_URL}/${warehouseId}`);
}
